import { createGlobalStyle } from 'styled-components';
import img from './eva.jpg';

const ExamsFStyle = createGlobalStyle`
body {
    background: url(${img}) no-repeat center center fixed;
    background-size: cover;
    background-color: #0a0a0a;
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0;
    min-height: 100vh;
    overflow-x: hidden;
}

/* Main Container */
.exams-form-main {
    min-height: calc(100vh - 140px);
    padding: 2rem 1rem;
}

.exams-form-container {
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
}

/* Header */
.exams-form-header {
    text-align: center;
    margin-bottom: 2rem;
}

.exams-form-header h2 {
    font-size: 2rem;
    font-weight: bold;
    color: #ffffff;
    background: rgba(0, 0, 0, 0.8);
    display: inline-block;
    padding: 1rem 2rem;
    border-radius: 10px;
    border: 2px solid #673ab7;
    box-shadow: 0 0 20px rgba(103, 58, 183, 0.4);
    text-shadow: 0 0 10px rgba(166, 13, 224, 0.6);
    margin: 0 0 1rem 0;
    animation: electric 0.8s infinite;
}

/* Progress Bar */
.progress-bar-container {
    position: relative;
    width: 100%;
    height: 40px;
    background: rgba(0, 0, 0, 0.8);
    border: 2px solid #673ab7;
    border-radius: 20px;
    margin: 2rem 0;
    overflow: hidden;
}

.progress-bar {
    height: 100%;
    background: linear-gradient(90deg, #673ab7 0%, #A60DE0 100%);
    transition: width 0.3s ease;
    box-shadow: 0 0 20px rgba(166, 13, 224, 0.6);
}

.progress-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #ffffff;
    font-weight: bold;
    font-size: 1rem;
    text-shadow: 0 0 10px rgba(0, 0, 0, 0.8);
    z-index: 1;
}

/* Timer */
#timer {
    font-size: 1.75rem;
    font-weight: bold;
    color: #ffffff;
    background-color: #ff0000;
    padding: 1rem 1.5rem;
    border-radius: 10px;
    border: 2px solid #ff0000;
    box-shadow: 0 0 20px rgba(255, 0, 0, 0.6);
    animation: electricbox 0.8s infinite;
    display: inline-block;
    margin: 0.5rem;
}

.timer-toggle-btn {
    padding: 0.75rem 1.5rem;
    background: linear-gradient(135deg, #333 0%, #555 100%);
    color: #ffffff;
    border: 2px solid #666;
    border-radius: 5px;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    margin-top: 0.5rem;
}

.timer-toggle-btn:hover {
    background: linear-gradient(135deg, #555 0%, #777 100%);
    border-color: #888;
    box-shadow: 0 0 20px rgba(255, 255, 255, 0.3);
    transform: scale(1.05);
}

/* Question Cards */
.question-card {
    background: linear-gradient(135deg, rgba(30, 10, 40, 0.75) 0%, rgba(60, 20, 80, 0.75) 100%);
    border: 2px solid #673ab7;
    border-radius: 10px;
    padding: 1.5rem;
    margin: 2rem 0;
    box-shadow: 0 0 0 rgba(103, 58, 183, 0.4), 0 0 20px rgba(166, 13, 224, 0.4);
    animation: shadow-move-purple 4s infinite alternate;
    backdrop-filter: blur(5px);
    position: relative;
    overflow: hidden;
}

.question-card::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: repeating-linear-gradient(
        0deg,
        transparent,
        transparent 2px,
        rgba(103, 58, 183, 0.03) 2px,
        rgba(103, 58, 183, 0.03) 4px
    );
    animation: scan 10s linear infinite;
    pointer-events: none;
}

@keyframes scan {
    0% { transform: translateY(0); }
    100% { transform: translateY(50%); }
}

@keyframes shadow-move-purple {
    0% {
        box-shadow: 0 0 0 rgba(103, 58, 183, 0.4), 0 0 20px rgba(166, 13, 224, 0.4);
    }
    25% {
        box-shadow: 10px 10px 10px rgba(166, 13, 224, 0.4), 0 0 20px rgba(103, 58, 183, 0.4);
    }
    50% {
        box-shadow: 20px 10px 0 rgba(103, 58, 183, 0.4), 0 0 20px rgba(166, 13, 224, 0.4);
    }
    75% {
        box-shadow: -10px -10px 10px rgba(166, 13, 224, 0.4), 0 0 20px rgba(103, 58, 183, 0.4);
    }
    100% {
        box-shadow: -10px -10px 0 rgba(103, 58, 183, 0.4), 0 0 20px rgba(166, 13, 224, 0.4);
    }
}

.question-text {
    font-size: 1.1rem;
    font-weight: bold;
    color: #ffffff;
    text-shadow: 0 0 10px rgba(166, 13, 224, 0.6);
    margin: 0 0 1rem 0;
    background: rgba(0, 0, 0, 0.6);
    padding: 0.75rem;
    border-radius: 5px;
    position: relative;
    z-index: 1;
}

/* Form Elements */
.answer-textarea {
    width: 100%;
    padding: 1rem;
    background: rgba(0, 0, 0, 0.8);
    border: 2px solid #673ab7;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(103, 58, 183, 0.3);
    font-size: 1rem;
    color: #ffffff;
    font-family: Arial, sans-serif;
    resize: vertical;
    transition: all 0.3s ease;
    box-sizing: border-box;
    margin: 0.5rem 0;
    position: relative;
    z-index: 1;
}

.answer-textarea::placeholder {
    color: rgba(166, 13, 224, 0.6);
}

.answer-textarea:hover {
    border-color: #A60DE0;
    box-shadow: 0 0 20px rgba(166, 13, 224, 0.5);
}

.answer-textarea:focus {
    outline: none;
    border-color: #A60DE0;
    box-shadow: 0 0 20px rgba(166, 13, 224, 0.5);
}

.file-input {
    padding: 0.75rem;
    background: rgba(0, 0, 0, 0.8);
    border: 2px solid #673ab7;
    border-radius: 5px;
    color: #ffffff;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s ease;
    width: 100%;
    box-sizing: border-box;
    margin: 0.5rem 0;
    position: relative;
    z-index: 1;
}

.file-input:hover {
    border-color: #A60DE0;
    box-shadow: 0 0 20px rgba(166, 13, 224, 0.5);
}

/* Submit Container */
.submit-container, .submit-section {
    text-align: center;
    margin: 2rem 0;
    padding: 2rem;
    background: linear-gradient(135deg, rgba(30, 10, 40, 0.75) 0%, rgba(60, 20, 80, 0.75) 100%);
    border: 2px solid #673ab7;
    border-radius: 10px;
    box-shadow: 0 0 20px rgba(103, 58, 183, 0.4);
    backdrop-filter: blur(5px);
}

/* Navigation Buttons */
.navigation-buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    margin: 2rem 0;
}

.nav-button {
    padding: 1rem 2rem;
    background: linear-gradient(135deg, #673ab7 0%, #A60DE0 100%);
    color: #ffffff;
    border: 2px solid #A60DE0;
    border-radius: 5px;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 0 20px rgba(103, 58, 183, 0.4);
}

.nav-button:hover:not(:disabled) {
    transform: scale(1.05);
    color: #ffff00;
    box-shadow: 0 0 40px rgba(166, 13, 224, 0.8);
    background: linear-gradient(135deg, #A60DE0 0%, #673ab7 100%);
    animation: electric 0.8s infinite;
}

.nav-button:disabled {
    opacity: 0.3;
    cursor: not-allowed;
    background: #444;
    border-color: #444;
}

.prev-button {
    margin-right: auto;
}

.next-button {
    margin-left: auto;
}

.submit-section {
    margin-left: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    padding: 1rem;
}

.submit-button {
    display: inline-block;
    padding: 1rem 2rem;
    background: linear-gradient(135deg, #673ab7 0%, #A60DE0 100%);
    color: #ffffff;
    text-decoration: none;
    border-radius: 5px;
    border: 2px solid #A60DE0;
    box-shadow: 0 0 20px rgba(103, 58, 183, 0.4);
    transition: all 0.3s ease;
    font-size: 1.1rem;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    cursor: pointer;
    margin-top: 1rem;
}

.submit-button:hover:not(:disabled) {
    transform: scale(1.05);
    color: #ffff00;
    box-shadow: 0 0 40px rgba(166, 13, 224, 0.8), inset 0 0 20px rgba(166, 13, 224, 0.3);
    background: linear-gradient(135deg, #A60DE0 0%, #673ab7 100%);
    animation: electric 0.8s infinite;
}

.submit-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #666;
}

/* Nav Menu */
header {
    background-color: #333;
    padding: 20px;
    padding-bottom: 30px;
    margin: 0 auto;
}

nav ul {
    margin: 0;
    padding: 0;
    list-style: none;
}

nav ul li {
    display: inline-block;
    margin-right: 20px;
}

nav ul li:last-child {
    margin-right: 0;
}

nav ul li a, nav ul li button {
    color: #fff;
    text-decoration: none;
    font-size: 20px;
    font-weight: bold;
    text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black;
}

nav ul li a:hover, nav ul li button:hover {
    color: #673ab7;
    text-shadow: 1px 1px 2px #673ab7, 0 0 1em #A60DE0, 0 0 0.2em yellow;
    animation: electric 0.8s infinite;
}

nav ul li button {
    background-color: transparent;
    border: none;
    cursor: pointer;
}

/* Footer - Handled by EnhancedFooter component */
/* footer {
    margin-top: auto;
    height: 60px;
    background-color: #333;
    color: #fff;
    text-align: center;
    font-size: 18px;
    padding-top: 20px;
} */

/* Animations */
@keyframes electric {
    0% {
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }
    50% {
        text-shadow: 2px 2px 8px yellow, 0 0 20px red;
    }
    100% {
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }
}

@keyframes electricbox {
    0% {
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }
    50% {
        box-shadow: 2px 2px 8px #ffff00, 0 0 20px #ff0000;
    }
    100% {
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }
}

/* Responsive Design */
@media (max-width: 768px) {
    .exams-form-main {
        padding: 1rem 0.75rem;
    }

    .question-card {
        padding: 1rem;
    }

    .exams-form-header h2 {
        font-size: 1.5rem;
        padding: 0.75rem 1.5rem;
    }

    #timer {
        font-size: 1.25rem;
        padding: 0.75rem 1rem;
    }

    .navigation-buttons {
        flex-direction: column;
    }

    .nav-button, .submit-button {
        width: 100%;
    }

    .prev-button, .next-button {
        margin: 0;
    }

    .submit-section {
        width: 100%;
        margin: 0;
    }
}
`;

export default ExamsFStyle;
